const DYTE_MEETING_LINK = '/dyte-meeting/';

export const buildDyteURL = dyteAuthToken => {
  return `${DYTE_MEETING_LINK}?authToken=${dyteAuthToken}`;
};

